import { getDeviceStateDataValueFromState } from '@/helpers/devices/stateHelper'
import type { StateItemMapEntry, StdState } from '@/types/devices'

export interface StatisticsReading {
  name: string
  value: number
  timestamp: string
}

export const getStatisticsReadingsFromMeasurements = (
  measurements: StateItemMapEntry,
  timestamp: string
): Record<string, StatisticsReading> | null => {
  const typedMeasurementsValue = measurements.Value as StateItemMapEntry[]
  if (typedMeasurementsValue?.length) {
    const measurementStatistics: Record<string, StatisticsReading> = {}
    for (const measurement of typedMeasurementsValue) {
      const typedMeasurementValue = measurement.Value as StateItemMapEntry[]
      if (typedMeasurementValue?.length) {
        for (const item of typedMeasurementValue) {
          if (item.Key === 'value') {
            measurementStatistics[measurement.Key] = {
              name: measurement.Key,
              value: item.Value as number,
              timestamp
            }
          }
        }
      }
    }
    return measurementStatistics
  }

  return null
}

export const getStatisticsReadingsFromSensor = (
  sensor: StateItemMapEntry,
  timestamp: string
): Record<string, StatisticsReading> | null => {
  const typedSensorValue = sensor.Value as StateItemMapEntry[]
  if (typedSensorValue?.length) {
    let measurementStatistics: Record<string, StatisticsReading> = {}
    for (const measurements of typedSensorValue) {
      measurementStatistics = {
        ...measurementStatistics,
        ...getStatisticsReadingsFromMeasurements(measurements, timestamp)
      }
    }

    return measurementStatistics
  }

  return null
}

export const getStatisticsReadingsFromSensors = (
  sensors: StateItemMapEntry[],
  timestamp: string
): Record<string, StatisticsReading> | null => {
  if (sensors?.length) {
    let measurementStatistics: Record<string, StatisticsReading> = {}
    for (const sensor of sensors) {
      measurementStatistics = {
        ...measurementStatistics,
        ...getStatisticsReadingsFromSensor(sensor, timestamp)
      }
    }
    return measurementStatistics
  }

  return null
}

export const getStatisticsReadingsFromState = (
  state: StdState,
  timestamp: string
): Record<string, StatisticsReading> | null => {
  const sensors = getDeviceStateDataValueFromState<StateItemMapEntry[]>(state, 'statistics')
  return getStatisticsReadingsFromSensors(sensors, timestamp)
}
